import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics } from "firebase/analytics"; // Analytics'i geri getirdik
import { getStorage } from "firebase/storage";

// DİKKAT: Buradaki bilgileri kendi gerçek Firebase ayarlarınla değiştirmeyi unutma!
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app); 
const googleProvider = new GoogleAuthProvider(); 

// Hata vermesin diye Analytics'i de tanımlıyoruz
const analytics = typeof window !== "undefined" ? getAnalytics(app) : null; 
const storage = getStorage(app);

// İŞTE BÜTÜN DÜĞÜMÜ ÇÖZEN SATIR (app ve analytics'i de listeye ekledik)
export { app, analytics, db, auth, googleProvider, storage };